import {
    IActivateMealsDTOOut,
    IBookedMealsToCancel,
    IBookMealsDTOOut,
    IMealsSettingsDTOOut,
} from '../../interfaces/meal.interface';
import { PaymentStatusEnum } from './../../enums/payment-status.enum';

// settings
export class GetSchoolMealsSettings {
    public static readonly type = '[Meals settings] get';
    constructor(public schoolId: number) {}
}

export class UpdateMealSetting {
    public static readonly type = '[Meal setting] update';
    constructor(public mealSetting: IMealsSettingsDTOOut) {}
}

// meals

export class ActivateMeals {
    public static readonly type = '[Meals] activate';
    constructor(public meals: IActivateMealsDTOOut) {}
}

export class DisableMeals {
    public static readonly type = '[Meals] disable';
    constructor(public meals: IActivateMealsDTOOut) {}
}

export class DisableMealsFullMonth {
    public static readonly type = '[Meals] disable full month';
    constructor(public monthDate: Date) {}
}

export class GetAllAvailableMeals {
    public static readonly type = '[Meals] get all available';
}

export class ResetMealsData {
    public static readonly type = '[Meals] reset data';
}

export class BookMeals {
    public static readonly type = '[Meals] book';
    constructor(public mealsToBook: IBookMealsDTOOut) {}
}

export class GetBookedMeals {
    public static readonly type = '[Booked meals] get';
}

export class CancelMealBooking {
    public static readonly type = '[Meal] cancel';
    constructor(public idsToCancel: IBookedMealsToCancel) {}
}

export class PostMealMenuFile {
    public static readonly type = '[Menu file] post';
    constructor(public date: Date, public file: any) {}
}

export class DeleteMealMenuFile {
    public static readonly type = '[Menu file[ delete';
    constructor(public date: Date) {}
}

export class GetMealMenuDatas {
    public static readonly type = '[Menu data] get';
}

export class GetBookedMealsPerMonth {
    public static readonly type = '[Meals] get booked meal per month';
    constructor(
        public payload: {
            from?: string;
            to?: string;
            search?: string;
            mealChoices?: string[];
            schoolId?: number;
            educationLevelId?: number;
            paymentStatus?: PaymentStatusEnum[];
        },
        public isFilter?: boolean
    ) {}
}

export class GetTotalOfBookedMealsPerMonth {
    public static readonly type = '[Meals] get total of booked meals per month';
}
